import React from 'react';
import { Link } from 'react-router-dom';

interface LetterNotFoundProps {
  title?: string;
  message?: string;
  showCreateNewButton?: boolean;
  showBackToHomeButton?: boolean;
}

/**
 * データが見つからなかった場合のエラーコンポーネント
 *
 * @example
 * // 基本的な使用方法
 * <LetterNotFound />
 *
 * @example
 * // カスタムメッセージ付き
 * <LetterNotFound
 *   title="ページが見つかりません"
 *   message="お探しのページは存在しません。"
 * />
 *
 * @example
 * // ボタンをカスタマイズ
 * <LetterNotFound
 *   showCreateNewButton={false}
 *   showBackToHomeButton={true}
 * />
 */
const LetterNotFound: React.FC<LetterNotFoundProps> = ({
  title = 'メッセージが見つかりません',
  message = '指定されたURLのメッセージは存在しないか、削除された可能性があります。',
  showCreateNewButton = true,
  showBackToHomeButton = true,
}) => {
  return (
    <div className='p-error-not-found'>
      <div className='p-error-not-found__inner'>
        <div className='p-error-not-found__icon'>
          <img src='/img/common/ic-logo.png' alt='SKALE' />
        </div>

        <div className='p-error-not-found__content'>
          <h2 className='p-error-not-found__title'>{title}</h2>
          <p className='p-error-not-found__message'>{message}</p>
        </div>

        <div className='p-error-not-found__actions'>
          {showCreateNewButton && (
            <div className='c-btn-width u-mb20'>
              <div className='c-btn-action'>
                <Link to='/question'>新しいメッセージを作成</Link>
              </div>
            </div>
          )}

          {showBackToHomeButton && (
            <div className='c-btn-width'>
              <div className='c-btn-action'>
                <Link to='/'>ホームに戻る</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LetterNotFound;
